import React, { useState, useEffect, useRef } from "react";
import cx from "classnames";

const PopUpCard = (props) => {
  const [error, setError] = useState(false);
  const errorImage =
    "https://media.giphy.com/media/Ke8JKfxe83FpLrra71/giphy.gif";
  let data = props;
  const { imageClassName = "" } = props;
  if (data && data.modalCard) {
    data = data.modalCard;
  }
  let text = data && data.flipped ? data.card.text : "GIFs Against Society";
  let gif = data && data.flipped ? data.card.gif_url : "";
  const imageRef = useRef(null);

  // There is a simple formula for calculating aspect ratios: aspectRatio = ( oldWidth / oldHeight ). For instance if you want to know the new height of an object, you can use: newHeight = ( newWidth / aspectRatio ), and if you need the new width of an object, you can use: newWidth = ( newHeight * aspectRatio ).

  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);
  const updateImageSize = () => {
    const currentWidth = imageRef.current.width;
    const currentHeight = imageRef.current.height;
    const aspectRatio = currentWidth / currentHeight;

    if (currentWidth === currentHeight || currentWidth < currentHeight) {
      setImageHeight(400);
      setImageWidth(400 * aspectRatio);
    } else {
      setImageHeight(420 / aspectRatio);
      setImageWidth(420);
    }
  };

  if (data && Object.keys(data).length > 0) {
    const imageStyle =
      imageWidth === 0
        ? { opacity: 0 }
        : {
            opacity: 1,
            // width: imageWidth,
            // height: imageHeight
          };
    return (
      <div
        className={cx("gameCard popCard", {
          blankCard: !data.flipped,
          gifCardCard: data.flipped,
        })}
      >
        {/* <div
          className="imageBox"
          style={{
            backgroundImage: `url(${gif})`,
          }}
        /> */}
        {gif ? (
          <img
            onLoad={() => updateImageSize()}
            src={error ? errorImage : gif}
            style={{ ...imageStyle }}
            ref={imageRef}
            className={cx("imageBox", imageClassName)}
            alt=""
            onError={() => setError(true)}
          />
        ) : (
          <div
            className="imageBox"
            style={{
              backgroundImage: `url(${error ? errorImage : gif})`,
            }}
          />
        )}
        {data.flipped ? (
          <p className="text bg-blue" title={text}>
            <span>{text}</span>
          </p>
        ) : (
          <p className="text">
            <span>{text}</span>
          </p>
        )}
      </div>
    );
  } else {
    return <></>;
  }
};

export default PopUpCard;
